/* ==========================================================================
 *  Initialization Google maps
 * ======================================================================= */
function fn_components_google_map(){
    $('.normal-map .map-block').each(function() {
        var inst = $(this);
        var id = inst.attr('id');
        var latitude = inst.data('latitude');
        var longitude = inst.data('longitude');
        var latlong = inst.data('latlong');
        fn_init_map(id, latlong, latitude, longitude);
    });
}

function fn_init_map(id, latlong, latitude, longitude){
    //rozdeleni souradnic pokud jich je vice
    var latlongArray = [];
    if(latlong !== undefined) {
        latlongArray = latlong.toString().split(";");
        //console.log(latlongArray);
    }

    var map;
    var mapOptions = {
        center: new google.maps.LatLng(latitude,longitude),
        zoom: 13,
        zoomControl: true,
        disableDoubleClickZoom: false,
        mapTypeControl: false,
        scaleControl: true,
        scrollwheel: false,
        panControl: true,
        streetViewControl: false,
        draggable : true,
        overviewMapControl: false,
        overviewMapControlOptions: {
            opened: false,
        },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            }
        ]
    }


    var mapElement = document.getElementById(id);
    var map = new google.maps.Map(mapElement, mapOptions);

    var bounds = new google.maps.LatLngBounds();

    var locations = [
        [ latitude,  longitude, '/public/img/map-marker.svg']
    ];

    // pokud je vice pobocek => udela autocenter
    if (latlongArray.length > 1) {
        for (i = 0; i < latlongArray.length; i++) {
            var latandlongArray = latlongArray[i].split(",");
            marker = new google.maps.Marker({
                icon: '/public/img/map-marker.svg',
                position: new google.maps.LatLng(latandlongArray[0], latandlongArray[1]),
                map: map
            });

            bounds.extend(marker.position);
        }

        //now fit the map to the newly inclusive bounds
        map.fitBounds(bounds);
    }
    else {
        for (i = 0; i < locations.length; i++) {
            marker = new google.maps.Marker({
                icon: locations[i][2],
                position: new google.maps.LatLng(locations[i][0], locations[i][1]),
                map: map
            });
        link = '';
        }
    }

}

/* ==========================================================================
 *  Initialization Seznam mapy
 * ======================================================================= */
function fn_components_seznam_map(){
    $('.normal-map .map-block').each(function() {
        var inst = $(this);
        var id = inst.attr('id');
        var latitude = inst.data('latitude');
        var longitude = inst.data('longitude');
        var latlong = inst.data('latlong');
        map_init(id, latlong, latitude, longitude);
    });
}

/* mapy.cz */
function map_init(mapId, latlong, latitude, longitude) {

    if (!document.getElementById(mapId)){
        return;
    }
    
    var latlongArray = [];
    
    if (latlong !== undefined) {
        latlongArray = latlong.toString().split(";");
    }
    
    // calculate center
    var center;
    if (latlongArray.length > 1) {
        latandlongArray = latlongArray[0].split(",");
        center = SMap.Coords.fromWGS84(latandlongArray[1], latandlongArray[0]);
    } else {
        center = SMap.Coords.fromWGS84(longitude, latitude);
    }

    // center map
    var m = new SMap(JAK.gel(mapId), center, 13);
    m.addDefaultLayer(SMap.DEF_BASE).enable();
    m.addDefaultControls();

    // disable mouse scroll
    var mouseControl = null;
    var controls = m.getControls();
    for (var i = 0; i < controls.length; i++) {
        if (controls[i] instanceof SMap.Control.Mouse) {
            mouseControl = controls[i];
        }
    }
    mouseControl.configure(SMap.MOUSE_PAN | SMap.MOUSE_ZOOM);

    // layer create
    var layer = new SMap.Layer.Marker();
    m.addLayer(layer);
    layer.enable();
    
    // def: image, points
    var image = "/public/img/map-marker.svg";
    var points = [];
    
    if (latlongArray.length > 1) {
        // multiple points
        for (i = 0; i < latlongArray.length; i++) {
            
            var latandlongArray = latlongArray[i].split(",");
            
            var point = SMap.Coords.fromWGS84(latandlongArray[1], latandlongArray[0]);
            
            var options = {
                url: image,
                anchor: {left: 16, bottom: -5}
            };
        
            var marker = new SMap.Marker(point, null, options);       
            layer.addMarker(marker);

            points.push(point);
        }
    } else {
        // one point
        var point = SMap.Coords.fromWGS84(longitude, latitude);
        
        var options = {
            url: image
        };

        var marker = new SMap.Marker(point, null, options);       
        layer.addMarker(marker);
    }
    
    // auto center and zoom
    if (points.length > 1) {
        var cz = m.computeCenterZoom(points);
        m.setCenterZoom(cz[0], cz[1]);
    }
}
